export default class ImageAddController {
  constructor(ImagesDataProvider, $state, Upload, $timeout, API_URL, APPLICATION_URL) {
    "ngInject"
    this.image = {};
    this.Upload = Upload;
    this.ImagesDataProvider = ImagesDataProvider;
    this.$state = $state;
    this.$timeout = $timeout;
    this.API_URL = API_URL;
    this.APPLICATION_URL = APPLICATION_URL;
    this.existRecord = 0;
    let
      vm = this;
    ImagesDataProvider.loadCategoriesNoLimit().then(function (result) {
      vm.mainCategories = result;
    });
  }

onvertToSlug(text) {
  return text
    .toString()
    .normalize('NFKD')                // Bryt ner bokstäver med diakritiska tecken
    .replace(/[\u0300-\u036f]/g, '')  // Ta bort diakritiska tecken (accents)
    .toLowerCase()
    .replace(/å/g, 'a')
    .replace(/ä/g, 'a')
    .replace(/ö/g, 'o')
    .replace(/æ/g, 'ae')
    .replace(/ø/g, 'oe')
    .replace(/\u00fc/g, 'ue')
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}

  saveData(form) {
    let
      vm = this;
    if (!form) {
      return false;
    }
    vm.__loading = true;
    if (vm.image.name)
      vm.image.slug = vm.onvertToSlug(vm.image.name);
    let
      file = vm.image.img;

    let data = {}
    data.name = vm.image.name;
    data.slug = vm.onvertToSlug(vm.image.name);
    data.image_category_id = vm.image.image_category_id;
    data.filename = new Date().valueOf() + file.name
    data.file = file;

    let chkData = {name: data.name, slug: data.slug}

    vm.ImagesDataProvider.checkRecordExist(chkData).then(function (res) {
      if (res.exist == 0) {
        file.upload = vm.Upload.upload({
          url: vm.APPLICATION_URL + '/api/upload',
          method: 'POST',
          data: {'image': file, 'max-w': '1200', 'max-h': '600'}
        });
        file.upload.then(function (response) {
          data.filename = new Date().valueOf() + file.name
          data.response = response.data;
          data.mime_type = file.type;
          vm.ImagesDataProvider.saveImageData(data).then(function (response) {
            vm.$timeout(function () {
              vm.$state.go('app.images');
            }, 5000);
          });
        }, function (response) {
          if (response.status > 0)
            alert(response.status + ': ' + response.data);
          vm.__loading = false;
        })
      }
      else {
        vm.existRecord = 1;
        vm.__loading = false;
      }
    });
  }

  change(file) {
    this.image.name = file.name.replace(/\.[^/.]+$/, "");
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/images/components/add/controller.js
 **/